import { createFileRoute } from '@tanstack/react-router'
import { LotoReportsPage } from 'pages/lotoReports/LotoReportsPage'

export const Route = createFileRoute('/loto-reports/')({
  component: LotoReportsPage,
  staticData: {
    title: 'LOTO Reports',
    layout: {
      enableScrolling: true,
    },
  },
})
